
export const BREAKPOINT_SMALL_VALUE = 968
export const BREAKPOINT_MEDIUM_VALUE = 1024
export const BREAKPOINT_LARGE_VALUE = 1223
export const BREAKPOINT_CONTENTABLE_MOBILE_VALUE = 500

enum Breakpoints {
	SMALL = '968px',
	MEDIUM = '1024px',
	LARGE = '1223px',
	CONTENTABLE_MOBILE = '500px',
}

export default Breakpoints